import React from 'react'
import { Link } from 'react-router-dom' // ← AGREGAR ESTA IMPORTACIÓN
import styles from './Home.module.css'

const Home = () => {
  // Datos de certificaciones organizados
  const certificaciones = [
    {
      id: 'ctpat',
      src: `${process.env.PUBLIC_URL}/CTPAT.png`,
      alt: 'CTPAT - Customs Trade Partnership Against Terrorism',
      title: 'CTPAT',
      description: 'Programa de asociación comercial contra el terrorismo'
    },
    {
      id: 'fast',
      src: `${process.env.PUBLIC_URL}/FAST.png`,
      alt: 'FAST - Free and Secure Trade',
      title: 'FAST',
      description: 'Programa de comercio libre y seguro'
    },
    {
      id: 'hazmat',
      src: `${process.env.PUBLIC_URL}/HAZMAT.png`,
      alt: 'HAZMAT - Hazardous Materials',
      title: 'HAZMAT',
      description: 'Certificación para materiales peligrosos'
    },
    {
      id: 'oea',
      src: `${process.env.PUBLIC_URL}/OEA.png`,
      alt: 'OEA - Operador Económico Autorizado',
      title: 'OEA',
      description: 'Operador Económico Autorizado'
    }
  ];

  // Función para manejar el scroll suave
  const handleSmoothScroll = (targetId) => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div id="Home" className={styles.home}>

      {/*portada........................................................................................*/}
      <div className={styles.imageContainer} id="inicio">
        <img 
          src={`${process.env.PUBLIC_URL}/Portada.png`}
          alt="Portada QS"
          className={styles.Portada1}
        />
        <div className={styles.textOverlay}>
          <p className={styles.heroTitle}>QS LOGISTICS</p>
          <b className={styles.heroSubtitle}>Conectando el mundo</b>
          <b className={styles.heroDescription}>Bienvenido a una logística sin complicaciones para tu vida</b>

            {/* ⭐ BOTÓN DE WHATSAPP EN FOOTER - AGREGAR AQUÍ */}
                <div className={styles.whatsappFooterContainer}>
                  <a 
                    href="https://wa.me/524151000229?text=Hola,%20necesito%20información%20sobre%20servicios%20de%20logística" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.whatsappFooterButton1}
                  >
                    <svg className={styles.whatsappFooterIcon} fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                    Contáctanos por WhatsApp
                  </a>
                </div>

                {/* Botón de cotización - MANTENER ESTE */}
                <div className={styles.ctaButton1}>
                  <Link 
                    to="/contact"
                    className={styles.quotationButton1}
                  >
                    Solicitar Cotización
                  </Link>
                </div>
        </div>
      </div>

      {/* Contenido del home - Layout Horizontal */}
      <div className={styles.heroSection} id="nosotros">
        <div className={styles.heroContent}>
          {/* Título principal con línea decorativa */}
          <h2 className={styles.compromiso}>Compromiso</h2>
          
          {/* Contenedor principal: texto izquierda, imagen derecha */}
          <div className={styles.heroMainContent}>
            <div className={styles.heroText}>
              <p className={styles.heroTextContent}>
                Somos un equipo de expertos, comprometidos para ofrecer el mejor servicio de logística 
                terrestre, nos encargamos de llevar tu mercancía de cualquier punto al destino que necesites.
              </p>
            </div>
            
            <div className={styles.heroImage}>
              <img 
                src={`${process.env.PUBLIC_URL}/Lugar.jpg`}
                alt="Lugar QS - Compromiso con la logística"
                className={styles.heroImg}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Sección de confianza de empresas........................................................ */}
      <div className={styles.trustSection} id="servicios">
        <h2 className={styles.trustTitle}>Servicios</h2>

        <div className={styles.serviceContainer}>
          <img 
            src={`${process.env.PUBLIC_URL}/Servicios1.png`}
            alt="Servicios QS"
            className={styles.serviceBackgroundImage}
          />
          
          <div className={styles.servicesContent}>
            {/* Sección de Transportes */}
            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Transportes</h3>
              <ul className={styles.serviceList}>
                <li>TRANSPORTE TERRESTRE DEDICADO</li>
                <li>SERVICIO PUERTA A PUERTA</li>
                <li>CONTENEDORES DE 20 DC // 40 HQ // FULL // ISOTANQUES</li>
                <li>CARGA CONSOLIDADA </li>
                <li>CARGA PELIGROSA</li>
                <li>CARGA REFRIGERADA</li>
                <li>CARGA SOBREDIMENSIONADA</li>
              </ul>
            </div>

            {/* Sección de Tipos de Carga */}
            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Otros</h3>
              <ul className={styles.serviceList}>
                <li>ALMACÉN ESTRATÉGICO</li>
                <li>SEGURO DE MERCANCÍA</li>
                <li>SEGURO DE CONTENEDORES</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/*CERTIFICACIONES MEJORADAS.............................................................................................*/}
      <div className={styles.certificacionesSection} id="certificaciones">
        <div className={styles.certificacionesContainer}>
          
          {/* Header de certificaciones */}
          <div className={styles.certificacionesHeader}>
            <h2 className={styles.certificacionesTitle}>Certificaciones</h2>
            <p className={styles.certificacionesDescription}>
              Las líneas de transportistas con las cuales tenemos alianzas comerciales son respaldadas 
              y se identifican por contar con certificaciones como las siguientes:
            </p>
          </div>

          {/* Grid de certificaciones */}
          <div className={styles.certificacionesGrid}>
            {certificaciones.map((cert, index) => (
              <div 
                key={cert.id} 
                className={styles.certificacionCard}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={styles.certificacionLogoContainer}>
                  <img 
                    src={cert.src}
                    alt={cert.alt}
                    className={styles.certificacionLogo}
                    loading="lazy"
                  />
                </div>
                <div className={styles.certificacionInfo}>
                  <h3 className={styles.certificacionTitleCard}>{cert.title}</h3>
                  <p className={styles.certificacionDesc}>{cert.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Sección de confianza adicional */}
          <div className={styles.certificacionesFooter}>
            <div className={styles.trustBadge}>
              <span className={styles.trustIcon}>🛡️</span>
              <p className={styles.trustText}>
                Nuestros socios transportistas cuentan con las certificaciones más estrictas 
                de la industria para garantizar la seguridad y eficiencia en cada envío.
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* FOOTER SECTION */}
      <footer className={styles.footer} id="contacto">
        <div className={styles.footerContainer}>
          
          {/* Grid principal del footer */}
          <div className={styles.footerGrid}>
            
            {/* Logo y descripción */}
            <div className={styles.footerSection}>
              <div className={styles.footerLogo}>
                <div className={styles.logoIcon}>
                  <span className={styles.truckIcon}>🚛</span>
                </div>
                <div className={styles.logoText}>
                  <h3 className={styles.logoTitle}>QS</h3>
                  <p className={styles.logoSubtitle}>LOGISTICS</p>
                </div>
              </div>
              <p className={styles.footerDescription}>
                Conectando el mundo a través de soluciones logísticas eficientes y seguras. 
                Tu socio confiable en transporte terrestre.
              </p>
            </div>

            {/* Mapa de sitio */}
            <div className={styles.footerSection}>
              <h4 className={styles.footerSectionTitle}>Mapa de sitio</h4>
              <ul className={styles.footerList}>
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('inicio')} 
                    className={styles.footerLink}
                  >
                    Principal
                  </button>
                </li>
                {/*
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('nosotros')} 
                    className={styles.footerLink}
                  >
                    Nosotros
                  </button>
                </li>
                */}
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('servicios')} 
                    className={styles.footerLink}
                  >
                    Servicios
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('certificaciones')} 
                    className={styles.footerLink}
                  >
                    Certificaciones
                  </button>
                </li>
                {/*
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('contacto')} 
                    className={styles.footerLink}
                  >
                    Contacto
                  </button>
                </li>
                */}
              </ul>
            </div>

            {/* Servicios */}
            <div className={styles.footerSection}>
              <h4 className={styles.footerSectionTitle}>Servicios</h4>
              <ul className={styles.footerList}>
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('servicios')} 
                    className={styles.footerLink}
                  >
                    Transporte Terrestre
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('servicios')} 
                    className={styles.footerLink}
                  >
                    Carga Consolidada
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('servicios')} 
                    className={styles.footerLink}
                  >
                    Carga Especializada
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('servicios')} 
                    className={styles.footerLink}
                  >
                    Almacén Estratégico
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleSmoothScroll('servicios')} 
                    className={styles.footerLink}
                  >
                    Seguros de Mercancía
                  </button>
                </li>
              </ul>
            </div>

            {/* Contacto */}
            <div className={styles.footerSection}>
              <h4 className={styles.footerSectionTitle}>Contacto</h4>
              
              <div className={styles.contactInfo}>
                <div className={styles.contactItem}>
                  <span className={styles.contactIcon}>✉️</span>
                  <div className={styles.contactDetails}>
                    <p className={styles.contactLabel}>Envía un correo directo:</p>
                    <a href="mailto:Jesus.Sanchez@qslogistics.mx" className={styles.contactValue}>
                      Jesus.Sanchez@qslogistics.mx
                    </a>
                  </div>
                </div>

                <div className={styles.contactItem}>
                  <span className={styles.contactIcon}>📞</span>
                  <div className={styles.contactDetails}>
                    <p className={styles.contactLabel}>Teléfono:</p>
                    <a href="tel:+524151000229" className={styles.contactValue}>
                      +52 415 1000 229
                    </a>
                  </div>
                </div>

                <div className={styles.contactItem}>
                  <span className={styles.contactIcon}>📍</span>
                  <div className={styles.contactDetails}>
                    <p className={styles.contactLabel}>Ubicación:</p>
                    <p className={styles.contactValue}>Querétaro, México</p>
                  </div>
                </div>
                {/* ⭐ BOTÓN DE WHATSAPP EN FOOTER - AGREGAR AQUÍ */}
                <div className={styles.whatsappFooterContainer}>
                  <a 
                    href="https://wa.me/524151000229?text=Hola,%20necesito%20información%20sobre%20servicios%20de%20logística" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.whatsappFooterButton}
                  >
                    <svg className={styles.whatsappFooterIcon} fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                    Contáctanos por WhatsApp
                  </a>
                </div>

                {/* Botón de cotización - MANTENER ESTE */}
                <div className={styles.ctaButton}>
                  <Link 
                    to="/contact"
                    className={styles.quotationButton}
                  >
                    Solicitar Cotización
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Línea divisoria */}
          <div className={styles.footerBottom}>
            <div className={styles.footerBottomContent}>
              
              {/* Copyright */}
              <div className={styles.copyright}>
                <p>&copy; 2025 QS Logistics. Todos los derechos reservados.</p>
              </div>
            </div>
          </div>

          {/* Botón volver arriba */}
          <div className={styles.backToTop}>
            <button 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={styles.backToTopButton}
            >
              ↑
            </button>
          </div>
        </div>
      </footer>

    </div>
  )
}

export default Home